<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="376" height="86" viewBox="0 0 376 86">
		<defs>
			<filter id="background" x="0" y="0" width="376" height="86" filterUnits="userSpaceOnUse">
				<feOffset dy="1" input="SourceAlpha" />
				<feGaussianBlur stdDeviation="1" result="blur" />
				<feFlood flood-opacity="0.161" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="Group_45730" data-name="Group 45730" transform="translate(3672 -22344)">
			<g transform="matrix(1, 0, 0, 1, -3672, 22344)" filter="url(#background)">
				<path
					id="background-2"
					data-name="background"
					d="M4,0H366a4,4,0,0,1,4,4V76a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
					transform="translate(3 2)"
					fill="#4285f4"
				/>
			</g>
			<g id="Group_45729" data-name="Group 45729">
				<g id="Group_45724" data-name="Group 45724" transform="translate(-3565.036 22373)">
					<g id="Group_45726" data-name="Group 45726">
						<path
							id="Path_32869"
							data-name="Path 32869"
							d="M11.156,15.777a2.105,2.105,0,0,0-.82-1.784A10.753,10.753,0,0,0,7.383,12.68a20.948,20.948,0,0,1-3.377-1.36Q.614,9.487.615,6.384a4.809,4.809,0,0,1,.909-2.878A5.941,5.941,0,0,1,4.135,1.531,9.832,9.832,0,0,1,7.957.82a8.965,8.965,0,0,1,3.8.772,6.06,6.06,0,0,1,2.59,2.181,5.7,5.7,0,0,1,.923,3.2h-4.1a2.683,2.683,0,0,0-.862-2.126,3.54,3.54,0,0,0-2.42-.758,3.776,3.776,0,0,0-2.337.635A2,2,0,0,0,4.717,6.4a1.918,1.918,0,0,0,.977,1.627A11.021,11.021,0,0,0,8.572,9.256a12.446,12.446,0,0,1,5.1,2.611,5.2,5.2,0,0,1,1.6,3.883A4.79,4.79,0,0,1,13.316,19.8a8.559,8.559,0,0,1-5.264,1.47,10.156,10.156,0,0,1-4.183-.841,6.617,6.617,0,0,1-2.878-2.3A5.9,5.9,0,0,1,0,14.738H4.115q0,3.294,3.937,3.3a3.828,3.828,0,0,0,2.284-.6,1.933,1.933,0,0,0,.82-1.661"
							fill="#fff"
						/>
						<path
							id="Path_32870"
							data-name="Path 32870"
							d="M17.816,2.379A1.944,1.944,0,0,1,18.411.916a2.232,2.232,0,0,1,1.62-.574,2.238,2.238,0,0,1,1.613.574,1.935,1.935,0,0,1,.6,1.463,1.942,1.942,0,0,1-.609,1.476,2.244,2.244,0,0,1-1.606.574,2.245,2.245,0,0,1-1.607-.574,1.942,1.942,0,0,1-.608-1.476M22.013,21H18.048V6.207h3.965Z"
							fill="#fff"
						/>
						<path
							id="Path_32871"
							data-name="Path 32871"
							d="M24.749,13.494a8.669,8.669,0,0,1,1.62-5.482,5.247,5.247,0,0,1,4.368-2.078A4.6,4.6,0,0,1,34.524,7.6l.164-1.394H38.27v14.3a6.322,6.322,0,0,1-.882,3.377,5.657,5.657,0,0,1-2.481,2.187,8.726,8.726,0,0,1-3.746.752,8.127,8.127,0,0,1-3.172-.649A5.623,5.623,0,0,1,25.651,24.5l1.75-2.406a4.631,4.631,0,0,0,3.582,1.654,3.385,3.385,0,0,0,2.447-.841,3.153,3.153,0,0,0,.875-2.386v-.793a4.566,4.566,0,0,1-3.6,1.545A5.236,5.236,0,0,1,26.4,19.188a8.666,8.666,0,0,1-1.647-5.53Zm3.951.294a5.393,5.393,0,0,0,.807,3.156,2.563,2.563,0,0,0,2.214,1.144,2.742,2.742,0,0,0,2.584-1.356V10.5a2.737,2.737,0,0,0-2.556-1.356,2.583,2.583,0,0,0-2.236,1.164,6.089,6.089,0,0,0-.813,3.478"
							fill="#fff"
						/>
						<path
							id="Path_32872"
							data-name="Path 32872"
							d="M45,6.207l.123,1.709a5.166,5.166,0,0,1,4.252-1.982,4.3,4.3,0,0,1,3.5,1.38,6.446,6.446,0,0,1,1.176,4.129V21H50.1V11.539a2.564,2.564,0,0,0-.547-1.825,2.451,2.451,0,0,0-1.819-.568,2.718,2.718,0,0,0-2.5,1.422V21H41.279V6.207Z"
							fill="#fff"
						/>
						<path
							id="Path_32873"
							data-name="Path 32873"
							d="M64.1,2.379a1.944,1.944,0,0,1,.6-1.463,2.563,2.563,0,0,1,3.233,0,1.935,1.935,0,0,1,.6,1.463,1.939,1.939,0,0,1-.609,1.476,2.535,2.535,0,0,1-3.213,0A1.942,1.942,0,0,1,64.1,2.379M68.3,21H64.332V6.207H68.3Z"
							fill="#fff"
						/>
						<path
							id="Path_32874"
							data-name="Path 32874"
							d="M75.244,6.207l.123,1.709a5.166,5.166,0,0,1,4.252-1.982,4.3,4.3,0,0,1,3.5,1.38,6.446,6.446,0,0,1,1.176,4.129V21H80.344V11.539A2.564,2.564,0,0,0,79.8,9.714a2.451,2.451,0,0,0-1.819-.568,2.718,2.718,0,0,0-2.5,1.422V21H71.525V6.207Z"
							fill="#fff"
						/>
						<path
							id="Path_32875"
							data-name="Path 32875"
							d="M107.239,15.627l1.941-9.42H113L109.221,21h-3.308l-2.8-9.311L100.307,21H97.012L93.239,6.207h3.814l1.928,9.406,2.707-9.406h2.858Z"
							fill="#fff"
						/>
						<path
							id="Path_32876"
							data-name="Path 32876"
							d="M114.979,2.379a1.947,1.947,0,0,1,.594-1.463,2.565,2.565,0,0,1,3.234,0,1.934,1.934,0,0,1,.6,1.463,1.942,1.942,0,0,1-.608,1.476,2.535,2.535,0,0,1-3.213,0,1.938,1.938,0,0,1-.608-1.476M119.176,21h-3.965V6.207h3.965Z"
							fill="#fff"
						/>
						<path
							id="Path_32877"
							data-name="Path 32877"
							d="M127.216,2.57V6.207h2.529V9.1h-2.529v7.383a1.763,1.763,0,0,0,.314,1.176,1.581,1.581,0,0,0,1.2.355,6.377,6.377,0,0,0,1.162-.095v2.994a8.138,8.138,0,0,1-2.393.355q-4.156,0-4.238-4.2V9.1h-2.16v-2.9h2.16V2.57Z"
							fill="#fff"
						/>
						<path
							id="Path_32878"
							data-name="Path 32878"
							d="M135.859,7.82a4.931,4.931,0,0,1,3.951-1.887q4.812,0,4.881,5.592V21H140.74V11.634a2.749,2.749,0,0,0-.547-1.879,2.344,2.344,0,0,0-1.818-.609,2.688,2.688,0,0,0-2.516,1.34V21h-3.951V0h3.951Z"
							fill="#fff"
						/>
						<path
							id="Path_32879"
							data-name="Path 32879"
							d="M170.765,18.484a7.122,7.122,0,0,1-3.131,2.058,13.123,13.123,0,0,1-4.484.731,8.879,8.879,0,0,1-4.532-1.128,7.525,7.525,0,0,1-3.008-3.274,11.528,11.528,0,0,1-1.087-5.045V10.472a12.238,12.238,0,0,1,1.005-5.161,7.433,7.433,0,0,1,2.9-3.336,9.546,9.546,0,0,1,9.974.533,7.215,7.215,0,0,1,2.365,4.915h-3.992a3.976,3.976,0,0,0-1.21-2.5,3.868,3.868,0,0,0-2.577-.792A3.638,3.638,0,0,0,159.8,5.7a8.266,8.266,0,0,0-1.107,4.676v1.271a7.874,7.874,0,0,0,1.189,4.731,4.074,4.074,0,0,0,3.487,1.6,4.548,4.548,0,0,0,3.294-.984V13.562h-3.732V10.541h7.834Z"
							fill="#fff"
						/>
						<path
							id="Path_32880"
							data-name="Path 32880"
							d="M173.269,13.467a8.772,8.772,0,0,1,.847-3.924,6.2,6.2,0,0,1,2.441-2.666,7.115,7.115,0,0,1,3.7-.943,6.735,6.735,0,0,1,4.888,1.832,7.351,7.351,0,0,1,2.112,4.976l.028,1.012a7.733,7.733,0,0,1-1.9,5.462,7.367,7.367,0,0,1-10.206.007,7.873,7.873,0,0,1-1.907-5.579Zm3.951.28a5.528,5.528,0,0,0,.793,3.225,2.848,2.848,0,0,0,4.512.013,6.054,6.054,0,0,0,.806-3.525,5.479,5.479,0,0,0-.806-3.2,2.623,2.623,0,0,0-2.27-1.137,2.578,2.578,0,0,0-2.242,1.13,6.148,6.148,0,0,0-.793,3.5"
							fill="#fff"
						/>
						<path
							id="Path_32881"
							data-name="Path 32881"
							d="M189.157,13.467A8.772,8.772,0,0,1,190,9.543a6.2,6.2,0,0,1,2.441-2.666,7.115,7.115,0,0,1,3.7-.943,6.735,6.735,0,0,1,4.888,1.832,7.351,7.351,0,0,1,2.112,4.976l.028,1.012a7.733,7.733,0,0,1-1.9,5.462,7.367,7.367,0,0,1-10.206.007,7.873,7.873,0,0,1-1.907-5.579Zm3.951.28a5.528,5.528,0,0,0,.793,3.225,2.848,2.848,0,0,0,4.512.013,6.054,6.054,0,0,0,.806-3.525,5.479,5.479,0,0,0-.806-3.2,2.623,2.623,0,0,0-2.27-1.137,2.578,2.578,0,0,0-2.242,1.13,6.148,6.148,0,0,0-.793,3.5"
							fill="#fff"
						/>
						<path
							id="Path_32882"
							data-name="Path 32882"
							d="M205.086,13.494a8.669,8.669,0,0,1,1.62-5.482,5.248,5.248,0,0,1,4.368-2.078A4.6,4.6,0,0,1,214.861,7.6l.164-1.394h3.582v14.3a6.322,6.322,0,0,1-.882,3.377,5.657,5.657,0,0,1-2.481,2.187,8.726,8.726,0,0,1-3.746.752,8.127,8.127,0,0,1-3.172-.649,5.623,5.623,0,0,1-2.338-1.675l1.75-2.406a4.633,4.633,0,0,0,3.582,1.654,3.385,3.385,0,0,0,2.447-.841,3.153,3.153,0,0,0,.875-2.386v-.793a4.566,4.566,0,0,1-3.6,1.545,5.237,5.237,0,0,1-4.314-2.085,8.666,8.666,0,0,1-1.647-5.53Zm3.951.294a5.393,5.393,0,0,0,.807,3.156,2.565,2.565,0,0,0,2.214,1.144,2.742,2.742,0,0,0,2.584-1.356V10.5a2.737,2.737,0,0,0-2.556-1.356,2.583,2.583,0,0,0-2.236,1.164,6.089,6.089,0,0,0-.813,3.478"
							fill="#fff"
						/>
						<rect id="Rectangle_15382" data-name="Rectangle 15382" width="3.965" height="21" transform="translate(221.904 0)" fill="#fff" />
						<path
							id="Path_32883"
							data-name="Path 32883"
							d="M235.987,21.273a7.261,7.261,0,0,1-5.3-2,7.093,7.093,0,0,1-2.044-5.318v-.383a8.926,8.926,0,0,1,.862-3.985,6.316,6.316,0,0,1,2.44-2.707,6.845,6.845,0,0,1,3.6-.951,6.136,6.136,0,0,1,4.778,1.915,7.775,7.775,0,0,1,1.743,5.427v1.614h-9.42a3.668,3.668,0,0,0,1.156,2.324,3.492,3.492,0,0,0,2.44.875,4.266,4.266,0,0,0,3.568-1.655l1.942,2.174a5.937,5.937,0,0,1-2.407,1.962,7.88,7.88,0,0,1-3.363.7m-.451-12.154a2.468,2.468,0,0,0-1.907.8,4.117,4.117,0,0,0-.937,2.279h5.5v-.316a2.944,2.944,0,0,0-.711-2.039,2.546,2.546,0,0,0-1.941-.721"
							fill="#fff"
						/>
					</g>
				</g>
				<g id="Group_45728" data-name="Group 45728">
					<path
						id="Path_32889"
						data-name="Path 32889"
						d="M3,0H73a3,3,0,0,1,3,3V73a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
						transform="translate(-3667 22348)"
						fill="#fff"
					/>
					<g id="Group_45727" data-name="Group 45727" transform="translate(-2462.068 23133.172)">
						<path
							id="Path_32884"
							data-name="Path 32884"
							d="M-1089.333-687.239v6.975h9.693a8.305,8.305,0,0,1-3.618,5.42l5.845,4.535a17.6,17.6,0,0,0,5.37-13.246,20.689,20.689,0,0,0-.328-3.684Z"
							transform="translate(-77.239 -63.196)"
							fill="#4285f4"
						/>
						<path
							id="Path_32885"
							data-name="Path 32885"
							d="M-1168.38-651.791l-1.318,1.009-4.666,3.635h0a18.007,18.007,0,0,0,16.078,9.938,17.19,17.19,0,0,0,11.919-4.355l-5.845-4.535a10.728,10.728,0,0,1-6.074,1.736,10.752,10.752,0,0,1-10.086-7.417Z"
							transform="translate(-8.285 -91.942)"
							fill="#34a853"
						/>
						<path
							id="Path_32886"
							data-name="Path 32886"
							d="M-1182.65-712.61a17.788,17.788,0,0,0-1.932,8.072,17.788,17.788,0,0,0,1.932,8.072c0,.016,5.993-4.65,5.993-4.65a10.792,10.792,0,0,1-.573-3.422,10.792,10.792,0,0,1,.573-3.422Z"
							transform="translate(0 -42.623)"
							fill="#fbbc05"
						/>
						<path
							id="Path_32887"
							data-name="Path 32887"
							d="M-1158.287-758a9.827,9.827,0,0,1,6.893,2.685l5.157-5.157a17.279,17.279,0,0,0-12.051-4.7,17.978,17.978,0,0,0-16.078,9.938l5.992,4.65A10.752,10.752,0,0,1-1158.287-758Z"
							transform="translate(-8.285)"
							fill="#ea4335"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'GoogleBtnSvg',
};
</script>

<style scoped lang="scss"></style>
